import { useState } from "react";
import { Link } from "react-router-dom";
import BrandLogo from "@/components/common/BrandLogo";

const COLUMNS = [
  {
    title: "Trade",
    links: [
      { label: "Markets", to: "/markets" },
      { label: "P2P", to: "/p2p" },
      { label: "OTC desk", to: "/otc" },
      { label: "Fees", to: "/fees" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Blog", to: "/blog" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Terms", to: "/terms" },
      { label: "Privacy", to: "/privacy" },
      { label: "Risk disclosure", to: "/risk-disclosure" },
      { label: "AML policy", to: "/aml-policy" },
    ],
  },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const onNewsletter = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubscribed(true);
    setEmail("");
    setTimeout(() => setSubscribed(false), 4000);
  };

  return (
    <footer className="mt-8 border-t border-border bg-surface" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 md:grid-cols-[1.4fr_repeat(3,1fr)]" data-testid="footer-main-grid">
        <div data-testid="footer-brand-col">
          <Link to="/" aria-label="PaisaCX home" className="inline-block cursor-pointer text-left">
            <BrandLogo size="lg" testId="footer-logo" />
          </Link>
          <p className="mt-3 max-w-xs text-sm text-muted-foreground">
            Peer-to-peer and OTC crypto trading with escrow protection and desk-grade liquidity.
          </p>
          <form className="mt-5 flex min-w-0 max-w-sm gap-2" onSubmit={onNewsletter}>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              aria-label="Email for updates"
              placeholder="you@company.com"
              data-testid="newsletter-email"
              className="w-full min-w-0 rounded-lg border border-border bg-surface-2 px-3 py-2 text-sm outline-none focus:border-primary"
            />
            <button
              type="submit"
              data-testid="newsletter-submit"
              className="shrink-0 rounded-lg border border-border bg-surface-2 px-3 text-sm transition hover:border-primary"
            >
              Subscribe
            </button>
          </form>
          {subscribed ? (
            <p className="mt-2 text-xs text-up" data-testid="newsletter-success">
              Thanks — you&apos;re subscribed.
            </p>
          ) : null}
        </div>

        {COLUMNS.map((col) => (
          <div key={col.title}>
            <h4 className="text-sm font-semibold">{col.title}</h4>
            <ul className="mt-3 space-y-2">
              {col.links.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-muted-foreground transition hover:text-foreground"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-border px-4 py-5 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} PaisaCX. Crypto trading carries risk.
      </div>
    </footer>
  );
}
